export default __webpack_public_path__ + "static/media/tiji.6f87d84e.png";